const defaultBaseScenarioCollectionData = {
    baseScenarioCollection: [],
    pages: [],
    currentPage: 0
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = defaultBaseScenarioCollectionData, action) => {
    switch(action.type) {
        case 'LOAD_SCENARIO_COLLECTION_FROM_API':
            return {
                baseScenarioCollection: action.baseScenarioCollectionData,
                currentPage: action.currentPage,
                pages: action.pages
            }

        case "UPDATE_BASE_SCENARIO_INFO":
            const modList = state.baseScenarioCollection.map((item) => {
                if(item.master_base_scenario_name === action.scenarioName){
                    item.isChecked = action.isChecked;
                    const modBaseList = item.base_scenario_list.map((subItem) => ({...subItem, isChecked:action.isChecked}))
                    return {...item , base_scenario_list:modBaseList}
                }
                return item
            } )

            return {
                ...state,
                baseScenarioCollection:modList
            }

        case "UPDATE_INNER_BASE_SCENARIO_INFO":
            const baseList = state.baseScenarioCollection.map((item) => {
                if(action.scenarioName.toLowerCase().includes(item.master_base_scenario_name.toLowerCase())){
                    const modBaseList = item.base_scenario_list.map((subItem) => {
                        if(subItem.base_scenario_name === action.scenarioName){
                            subItem.isChecked = action.isChecked;
                            return subItem
                        }
                        return subItem;
                    })
                    return {...item , base_scenario_list:modBaseList}
                }
                return item
            })
            return {
                ...state,
                baseScenarioCollection:baseList
            }


        default:
            return state
    }
};